'use client';
import { SectionContainer } from '../component/SectionContainer';
import ReportResourceList from '../_bs-components/ReportResourceList';
import { IReportResourceItem } from '../type';

export default function MeetingDownReportSection({
  title,
  data = [],
}: {
  title: string;
  data: IReportResourceItem[];
}) {
  return (
    <SectionContainer title={title} contentClassName="max-w-auto !px-0">
      <ReportResourceList list={data}></ReportResourceList>
    </SectionContainer>
  );
}
